import { render } from "./ReportByServicesDatatableTDService.vue?vue&type=template&id=2ee38327"
import script from "./ReportByServicesDatatableTDService.vue?vue&type=script&lang=js"
export * from "./ReportByServicesDatatableTDService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__